export default {"src":"/_next/static/media/features-marketing-automations.fb9180ec.svg","height":59,"width":58,"blurWidth":0,"blurHeight":0};